var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { notification } from "antd";
import { CERTIFICATION_COMP_POPUPS, CERTIFICATION_START_POPUP, COMPANY_TAG, DOCUMENT_TAG, GROUP_TAG, PERSON_TAG } from "./Constants";
import Cookies from 'js-cookie';
import classNames from "classnames";
import _ from 'lodash';
import { useMediaQuery } from "react-responsive";
import { alertArticlePlaceholder, pdfFileIcon, pptFileIcon, txtFileIcon, wordFileIcon, aboutPerson, aboutPersonAtive, aboutcompany, aboutcompanyActive, aboutgroup, aboutgroupActive, competitor, competitorActive, emailLibrary, emailLibraryActive, linkedin, linkedinActive, market, marketActive, imgFileIcon, excelFileIcon, csvFileIcon, } from "./utilsStyle";
export var MaxWidthApp = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1500px)',
    });
    return isResolution;
};
export var Retina125 = function () {
    var isResolution = useMediaQuery({
        query: '(-webkit-device-pixel-ratio: 1.25)',
    });
    return isResolution;
};
export var MaxWidthAppV2 = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1450px)',
    });
    return isResolution;
};
export var MidWidthApp = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1280px)',
    });
    return isResolution;
};
export var MidWidth1300 = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1300px)',
    });
    return isResolution;
};
export var MidWidthApp1200 = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1200px)',
    });
    return isResolution;
};
export var MinWidthApp = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1100px)',
    });
    return isResolution;
};
export var IsTablet = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1023px)',
    });
    return isResolution;
};
export var MidTablet = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 993px)',
    });
    return isResolution;
};
export var IsMobile = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 767px)',
    });
    return isResolution;
};
export var IsMobileSm = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 577px)',
    });
    return isResolution;
};
export var IsMobileM = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 650px)',
    });
    return isResolution;
};
export var IsMobileSm400 = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 400px)',
    });
    return isResolution;
};
export var XsmHeight = function () {
    var isResolution = useMediaQuery({
        query: '(max-height: 690px)',
    });
    return isResolution;
};
export var IsMobileXsm = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 380px)',
    });
    return isResolution;
};
export var IsWidth1300 = function () {
    var isResolution = useMediaQuery({
        query: '(max-width: 1300px)',
    });
    var endResolution = useMediaQuery({
        query: '(min-width: 1023px)',
    });
    if (isResolution && endResolution) {
        return true;
    }
    return false;
};
export var getLocalStorageValue = function (key) { return localStorage
    .getItem(key); };
export var setLocalStorageValue = function (key, value) { return localStorage
    .setItem(key, value); };
export var getSessionStorageValue = function (key) { return sessionStorage
    .getItem(key); };
export var setSessionStorageValue = function (key, value) { return sessionStorage
    .setItem(key, value); };
export var setLocalStorageObject = function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
};
export var getLocalStorageObject = function (key) {
    var data = localStorage.getItem(key);
    var parse = JSON.parse(data || '{}');
    return parse;
};
export var isEnterpriseUser = function () {
    var _a;
    var flag = false;
    var userPlan = (_a = getLocalStorageValue('userPlan')) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    if (userPlan && userPlan === 'ENTERPRISE') {
        flag = true;
    }
    return flag;
};
export var isSafariBrowser = function () {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
};
export var removeHtmlTags = function (input) {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || '';
};
var getDataToAppend = function (objectItem) {
    var typeOfObjectItem = typeof objectItem;
    if (objectItem instanceof File)
        return objectItem;
    if (typeOfObjectItem === 'object') {
        return JSON.stringify(objectItem);
    }
    return String(objectItem);
};
export var objToFormData = function (obj) { return Object.keys(obj)
    .reduce(function (formData, key) {
    formData.append(key, getDataToAppend(obj[key]));
    return formData;
}, new FormData()); };
export var getAppName = function () {
    if (window.location.hostname.includes('salesforce'))
        return 'salesforce';
    return 'xiq-workbench';
};
export var setCookie = function (key, value) {
    var date = new Date(new Date().getTime());
    var hostname = window.location.hostname;
    var opts = {
        expires: new Date(date.setMonth(date.getMonth() + 6)),
        domain: '.xiqonline.com',
        secure: true,
    };
    if (hostname === 'localhost') {
        Cookies.set(key, value);
    }
    else {
        Cookies.set(key, value, opts);
    }
};
export var loginNavigation = function (url) {
    if (url === void 0) { url = ''; }
    var route = window.location.search || '/';
    if (isActive()) {
        if (url !== '') {
            window.location.replace(url);
        }
        else {
            var _a = route.split('/'), address = _a[0], others = _a.slice(1);
            if (others.length) {
                window.location.replace("/".concat(others.join('/')));
            }
            else {
                window.location.replace(address);
            }
        }
    }
};
export var navigateToAuthServer = function (location, isProfileLogin) {
    if (location === void 0) { location = '/'; }
    if (isProfileLogin === void 0) { isProfileLogin = false; }
    var authServer = process.env.REACT_APP_AUTH_SERVER_URL || '';
    var callBackUrl = process.env.REACT_APP_CALLBACK_URL || '';
    window.location.href = "".concat(authServer, "?").concat(isProfileLogin ? 'isLogout=1' : '', "&redirectURL=").concat(callBackUrl).concat(location !== '/' && !location.includes('/sso')
        ? "&navigateTo=".concat(location)
        : '');
};
export var resetOnlogout = function (location, setIsLogout, isProfileLogin) {
    if (location === void 0) { location = '/'; }
    if (setIsLogout === void 0) { setIsLogout = false; }
    if (isProfileLogin === void 0) { isProfileLogin = false; }
    // eslint-disable-next-line no-console
    console.log('reset logout called');
    var welcomePopupFlag = getLocalStorageValue('welcomePopupFlag');
    var getArticleView = getLocalStorageObject('ViewTab');
    var certificationFlag = getLocalStorageValue(CERTIFICATION_START_POPUP);
    var popupFlag = getLocalStorageValue(CERTIFICATION_COMP_POPUPS);
    localStorage.clear();
    if (setIsLogout)
        setCookie('isLogout', '1');
    if (welcomePopupFlag) {
        setLocalStorageValue('welcomePopupFlag', 'true');
    }
    if (getArticleView) {
        setLocalStorageObject('ViewTab', { view: getArticleView.view });
    }
    if (certificationFlag) {
        setLocalStorageValue(CERTIFICATION_START_POPUP, 'true');
    }
    if (popupFlag) {
        setLocalStorageValue(CERTIFICATION_COMP_POPUPS, 'true');
    }
    navigateToAuthServer(location, isProfileLogin);
};
export var getResultArray = function (data, type) {
    var array = [];
    if (data) {
        var ids = data.split(',');
        if (ids.length) {
            for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
                var id = ids_1[_i];
                array.push(type);
            }
        }
    }
    return array;
};
export var handleException = function () {
    notification.open({
        top: 80,
        className: classNames({ errorNotification: true }, { centerMessage: true }),
        message: 'Something went wrong. Please try again',
    });
};
export var getCurrentTime = function () { return new Date().getTime() / 1000; };
export var getSessionId = function () {
    var sessionId = sessionStorage.getItem('branch_session');
    if (sessionId) {
        sessionId = JSON.parse(sessionId).session_id;
    }
    return sessionId;
};
export var valueToObject = function (name, time, info) {
    var snakeToCamel = {};
    for (var i in info) {
        snakeToCamel[i
            .split(/(?=[A-Z])/)
            .join('_')
            .toLowerCase()] = info[i];
    }
    if ('page' in snakeToCamel) {
        snakeToCamel.current_page = snakeToCamel.page;
        _.unset(snakeToCamel, 'page');
    }
    var obj = __assign(__assign(__assign({ eventname: name }, (info
        && !info.isDeleteTime && {
        loading_time: _.round(getCurrentTime() - time, 2),
    })), { session_id: getSessionId(), version: 2.0 }), snakeToCamel);
    if ('is_delete_time' in obj) {
        _.unset(obj, 'is_delete_time');
    }
    if ('is_called' in obj) {
        _.unset(obj, 'loading_time');
        _.unset(obj, 'current_page');
        _.unset(obj, 'is_called');
    }
    return obj;
};
export var isElement = function (element, offset) {
    if (element) {
        var yOffset = offset;
        var yScroll = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: yScroll, behavior: 'smooth' });
    }
};
export var extractSpanIdsFromHTML = function (htmlString) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    var spanElements = tempDiv.querySelectorAll('span');
    var results = [];
    spanElements.forEach(function (span) {
        var _a, _b, _c;
        var id = parseInt((_b = (_a = span.getAttribute('id')) === null || _a === void 0 ? void 0 : _a.replace('%', '')) !== null && _b !== void 0 ? _b : '', 10);
        var key = (_c = span.getAttribute('key')) !== null && _c !== void 0 ? _c : '';
        if (key === null || key === void 0 ? void 0 : key.length) {
            results.push(id);
        }
    });
    return results;
};
export var extractSpanTagFromString = function (input) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(input, 'text/html');
    return doc.querySelector('span');
};
export var extractSpanTagsFromHTML = function (htmlString) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    var spanElements = tempDiv.querySelectorAll('span');
    var results = [];
    spanElements.forEach(function (span) {
        var _a, _b, _c, _d;
        var id = parseInt((_a = span.getAttribute('id')) !== null && _a !== void 0 ? _a : '', 10);
        var key = (_b = span.getAttribute('key')) !== null && _b !== void 0 ? _b : '';
        var name = span.innerText.replace(/@/g, '');
        var image = (_c = span.dataset.image) !== null && _c !== void 0 ? _c : '';
        var color = (_d = span.dataset.color) !== null && _d !== void 0 ? _d : '';
        if (key === null || key === void 0 ? void 0 : key.length) {
            results.push({
                type: key,
                id: id,
                name: name,
                image: image,
                color: color,
            });
        }
    });
    return results;
};
export var getLangCookie = function () {
    var cookieValue = Cookies.get('xiqtrans');
    return cookieValue !== undefined ? cookieValue : 'en';
};
export var getTimezoneInGMT = function () {
    var date = new Date();
    var utcOffsetMinutes = date.getTimezoneOffset();
    var utcOffsetHours = -utcOffsetMinutes / 60;
    var sign = utcOffsetHours >= 0 ? '+' : '-';
    return "GMT".concat(sign).concat(Math.abs(utcOffsetHours).toString().padStart(2, '0'), "00");
};
export var formatNumberWithCommas = function (value) { return new Intl.NumberFormat('en-US').format(value); };
export var backgroundColorParsing = function (personality) {
    if (personality.length < 1)
        return '#979797 50%, #979797 50% ';
    if (personality.length > 1) {
        return "".concat(personality[0].color, " 50%, ").concat(personality[1].color, " 100%");
    }
    return "".concat(personality[0].color, " 50%, ").concat(personality[0].color, " 100%");
};
export var isXiqUser = function () {
    var email = getLocalStorageValue('email');
    var emailDomain = email === null || email === void 0 ? void 0 : email.split('@')[1].toLowerCase();
    if (emailDomain === 'xiqinc.com') {
        return true;
    }
    return false;
};
export var imageSource = function (type) {
    switch (type) {
        case 'pdf':
            return pdfFileIcon;
        case 'doc':
            return wordFileIcon;
        case 'docx':
            return wordFileIcon;
        case 'txt':
            return txtFileIcon;
        case 'pptx':
            return pptFileIcon;
        case 'ppt':
            return pptFileIcon;
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'svg':
            return imgFileIcon;
        case 'xls':
        case 'xlsx':
            return excelFileIcon;
        case 'csv':
            return csvFileIcon;
        default:
            return alertArticlePlaceholder;
    }
};
export var parseColorGradientMixture = function (obj) {
    var _a, _b;
    var personality = obj;
    var coloring = '';
    if (personality.length) {
        if (personality.length === 1) {
            coloring += "".concat((_a = personality[0]) === null || _a === void 0 ? void 0 : _a.color, " 0deg,").concat((_b = personality[0]) === null || _b === void 0 ? void 0 : _b.color, " 360deg ");
        }
        else {
            personality
                && (personality === null || personality === void 0 ? void 0 : personality.forEach(function (p, i) {
                    var _a;
                    if (p.start === '0%') {
                        coloring += " ".concat(p.color, " ").concat("".concat(360 / (100 / parseInt(p.end)), "deg"), ",");
                    }
                    else if (i === personality.length - 1) {
                        coloring += "".concat(p.color, " ").concat("".concat(360 / (100 / parseInt(p.end)) - 10, "deg"), ",");
                        coloring += "".concat((_a = personality[0]) === null || _a === void 0 ? void 0 : _a.color);
                    }
                    else {
                        coloring += "".concat(p.color, " ").concat("".concat(360 / (100 / parseInt(p.end)), "deg"), ",");
                    }
                    return null;
                }));
        }
    }
    return coloring;
};
export var parseColorGradients = function (obj) {
    var _a;
    var coloring = '';
    if (obj.length === 1) {
        coloring += "".concat((_a = obj[0]) === null || _a === void 0 ? void 0 : _a.color);
    }
    else {
        obj.map(function (p, i) {
            if (p.start === '0%') {
                coloring += " ".concat(p.color, " ").concat(p.end, ",");
            }
            else if (i === obj.length - 1) {
                coloring += " ".concat(p.color, " ").concat(p.start, ", ").concat(p.color, " ").concat(p.end);
            }
            else {
                coloring += " ".concat(p.color, " ").concat(p.start, ", ").concat(p.color, " ").concat(p.end, ",");
            }
            return null;
        });
    }
    return coloring;
};
export var isActive = function () {
    var active = false;
    var csrfToken = getLocalStorageValue('csrfToken');
    if (csrfToken && csrfToken !== '') {
        active = true;
    }
    return active;
};
export var isFreeUser = function () {
    var flag = false;
    var userPlan = getLocalStorageValue('userPlan');
    if (userPlan && userPlan === 'FREE') {
        flag = true;
    }
    return flag;
};
export var isGuest = function () {
    var guest = false;
    var username = getLocalStorageValue('username') || '';
    if (username === 'guest@xiqinc.com') {
        guest = true;
    }
    return guest;
};
export var checkInitialRoute = function () {
    var _a, _b;
    return ((_a = getSessionStorageValue('initialRoute')) === null || _a === void 0 ? void 0 : _a.length)
        && ((_b = getSessionStorageValue('initialRoute')) === null || _b === void 0 ? void 0 : _b.includes('/feed'));
};
export var isSalesforce = function () {
    var flag = false;
    if (window.location.hostname.includes('salesforce-salesapp')) {
        if (checkInitialRoute()) {
            flag = false;
        }
        else {
            flag = true;
        }
    }
    return flag;
};
export var showCertificationInApp = function () { return isActive()
    && !isFreeUser()
    && !isGuest()
    && !MinWidthApp()
    && !isSalesforce(); };
export var getCurrentDate = function () {
    var now = new Date();
    return now.toLocaleDateString();
};
export var scrollToElement = function (targetId, ref) {
    var targetElement = document.getElementById(targetId);
    if (targetElement && ref) {
        var container = ref;
        container.scrollTo({
            top: targetElement.offsetTop - 48,
            behavior: 'smooth',
        });
    }
};
export var scrollToTarget = function (targetClass, ref) {
    var container = ref;
    if (container) {
        var targetElements = container.querySelectorAll(targetClass);
        if (targetElements.length > 0) {
            var lastTargetElement = targetElements[targetElements.length - 1];
            container.scrollTo({
                top: lastTargetElement.offsetTop - 48,
                behavior: 'smooth',
            });
        }
    }
};
export var replaceTags = function (input) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(input, 'text/html');
    var spanElements = doc.querySelectorAll('span');
    var updatedInput = input.replace(/=""/g, '');
    spanElements === null || spanElements === void 0 ? void 0 : spanElements.forEach(function (spanElement) {
        var keyAttribute = spanElement.getAttribute('key');
        if (keyAttribute) {
            var tagSpanElement = spanElement.outerHTML;
            tagSpanElement = tagSpanElement.replace(/=""/g, '');
            if (keyAttribute === 'person') {
                updatedInput = updatedInput.replace(tagSpanElement, PERSON_TAG);
            }
            else if (keyAttribute === 'company') {
                updatedInput = updatedInput.replace(tagSpanElement, COMPANY_TAG);
            }
            else if (keyAttribute === 'group') {
                updatedInput = updatedInput.replace(tagSpanElement, GROUP_TAG);
            }
            else if (keyAttribute === 'document') {
                updatedInput = updatedInput.replace(tagSpanElement, DOCUMENT_TAG);
            }
        }
    });
    return updatedInput;
};
export var setIconForCategory = function (title, topIcon, hoverIcon) {
    switch (title) {
        case 'Person insights':
            topIcon(aboutPerson);
            hoverIcon(aboutPersonAtive);
            break;
        case 'Company analysis':
            topIcon(aboutcompany);
            hoverIcon(aboutcompanyActive);
            break;
        case 'Email':
            topIcon(emailLibrary);
            hoverIcon(emailLibraryActive);
            break;
        case 'Group insights':
            topIcon(aboutgroup);
            hoverIcon(aboutgroupActive);
            break;
        case 'Social selling':
            topIcon(linkedin);
            hoverIcon(linkedinActive);
            break;
        case 'Competitor overview':
            topIcon(competitor);
            hoverIcon(competitorActive);
            break;
        case 'Market intelligence':
            topIcon(market);
            hoverIcon(marketActive);
            break;
        default:
            topIcon(emailLibrary);
            hoverIcon(emailLibraryActive);
    }
};
export var saveUserDetails = function (userInfo, rememberMe, isGuest) {
    var _a;
    if (rememberMe === void 0) { rememberMe = false; }
    if (isGuest === void 0) { isGuest = false; }
    var personalityColors;
    if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePic) {
        setLocalStorageValue('profilePic', userInfo.profilePic);
    }
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.personCard) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.personCard.length)) {
        personalityColors = backgroundColorParsing(((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.personCard[0]) === null || _a === void 0 ? void 0 : _a.personalityTypes) || []);
        setLocalStorageValue('personDesignation', userInfo === null || userInfo === void 0 ? void 0 : userInfo.personCard[0].personDesignation);
    }
    if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userType) {
        setLocalStorageValue('userType', userInfo.userType);
    }
    // if (userInfo?.phone) {
    //   setLocalStorageValue('phone', userInfo.phone);
    // }
    setLocalStorageValue('csrfToken', userInfo.csrfToken);
    if (isGuest) {
        setLocalStorageValue('active', '0');
        setLocalStorageValue('username', 'guest@xiqinc.com');
    }
    else {
        setLocalStorageValue('active', userInfo.active ? '1' : '0');
        setLocalStorageValue('username', '');
        setLocalStorageValue('userPlan', userInfo.userPlan);
    }
    setLocalStorageValue('email', userInfo.email);
    setLocalStorageValue('fullname', userInfo.fullName);
    setLocalStorageValue('skipOnBoarding', userInfo.skipOnBoarding ? '1' : '0');
    setLocalStorageValue('subscription', userInfo.emailNotification === 1 ? 'True' : 'False');
    setLocalStorageValue('access_id', userInfo.jwt);
    if (personalityColors) {
        setLocalStorageValue('personalitycolors', personalityColors);
    }
    if (userInfo.companyName && userInfo.companyName.length) {
        setLocalStorageValue('personCompany', userInfo.companyName);
    }
    if (userInfo.userCompliancePopup && Object.keys(userInfo.userCompliancePopup).length) {
        setLocalStorageValue('userCompliancePopup', JSON.stringify(userInfo.userCompliancePopup));
    }
    if (rememberMe) {
        setCookie('userName', userInfo.fullName);
        setCookie('image', userInfo.profilePic);
        setCookie('email', userInfo.email);
    }
    setLocalStorageValue('xiqtrans', userInfo.defaultLanguage || 'en');
};
